import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSetNotification } from '../../../context/Notification';
import envVars from '../../../constants/envVars';
import useRequest from '../../../hooks/useRequest';
import { MemberReEnrollPayload, MemberReEnrollResponse } from '../types';
import { ORGANIZATION_MEMBER_LIST_KEY } from './constants';

const useMemberReEnroll = (onSuccess?: (response: MemberReEnrollResponse) => void) => {
    const req = useRequest();
    const queryClient = useQueryClient();
    const setNotification = useSetNotification();

    const request = ({ payload }: { payload: MemberReEnrollPayload }) => {
        return req<MemberReEnrollResponse>({
            url: `${envVars.API_COMMERCE_HOSTNAME}/enterprise/re-enroll-member/`,
            method: 'POST',
            body: JSON.stringify(payload)
        });
    };

    return useMutation({
        mutationFn: request,
        onSuccess: (response) => {
            queryClient.invalidateQueries({ queryKey: [ORGANIZATION_MEMBER_LIST_KEY] });
            setNotification({ message: 'Member re-enrolled' });
            onSuccess && onSuccess(response);
        },
        onError: (error?: string) => {
            return error;
        }
    });
};

export default useMemberReEnroll;
